/*global eclipseApp, $, console, angular*/
(function () {

  'use strict';

  eclipseApp

    .factory('provinceService', ['$rootScope', 'uteModal', '$state', 'cartManager', '$translate', '$q', 'uteLocale', function ($rootScope, uteModal, $state, cartManager, $translate, $q, uteLocale) {

      var provinceService = {
        // update rootscope, set samkey as default
        update: function (province) {
          cartManager.cleanCart(true).then(function () {
            $rootScope.userPref.samKey = 'default';
            $rootScope.atg = {
              userId: {
                value: 'default'
              },
              hashKey: {
                value: 'default'
              }
            };
            uteLocale.province = province;
          });
        },

        // check with user if switching to a province that doesn't have the current service is ok
        checkFootPrint: function (province) {

          var promises, requiredService = null, deferred = $q.defer();

          // check if there is a service dependency for this state
          if ($state.current.data && $state.current.data.service) {
            requiredService = $state.current.data.service;
          }

          // if the requested province doesn't have current footprint, prompt user
          if (requiredService && !$rootScope.ruiMethods.serviceAvailable(requiredService, province)) {
            if(requiredService == 'btsPromotion'){
              promises = [
                $translate('global.label.nonServiceableProvince'),
                $translate('global.message.nonServiceableOfferProvince'),
                $translate('global.label.' + requiredService),
                $translate('global.province.' + province + '.name'),
                $translate('global.cta.cancel'),
                $translate('global.cta.nonServiceableProvince'),
                $translate('global.province.' + province + '.abbr')
              ];
            }else{
              promises = [
                $translate('global.label.nonServiceableProvince'),
                $translate('global.message.nonServiceableProvince'),
                $translate('global.label.' + requiredService),
                $translate('global.province.' + province + '.name'),
                $translate('global.cta.cancel'),
                $translate('global.cta.nonServiceableProvince'),
                $translate('global.province.' + province + '.abbr')
              ];
            }
            $q.all(promises).then(function (responses) {
              console.log('--success');

              var replaceMessageChar = function () {
                if (responses[6].toUpperCase() === 'QC') {
                  return responses[1].replace('[service]', responses[2]).replace('en', 'au').replace('[prov]', responses[3]);
                }
                return responses[1].replace('[service]', responses[2]).replace('[prov]', responses[3]);
              };

              var replaceOkButtonChar = function () {
                if (responses[6].toUpperCase() === 'BC') {
                  return responses[5].replace('[prov]', 'B.C.');
                }
                if (responses[6].toUpperCase() === 'QC') {
                  return responses[5].replace('en', 'au').replace('[prov]', responses[6]);
                }
                return responses[5].replace('[prov]', responses[6]);
              };

              uteModal.open({
                title: responses[0],
                message: replaceMessageChar(),
                ok: function () {
                  console.log('--------ok prov');
                  // return resolved promise
                  deferred.resolve(province);
                  $state.go('home');
                },
                cancel: function () {
                  // return rejected promise
                  deferred.reject(uteLocale.province);
                },
                okButtonLabel: replaceOkButtonChar(),
                cancelButtonLabel: responses[4]
              });
            });
          } else {
            deferred.resolve(province);
          }

          return deferred.promise;
        }
      };

      return provinceService;

    }]);

})();
